module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 174.15d74c4b.png";